module.exports = __webpack_public_path__ + "img/line-pay.9a28c185.svg";